// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSwitcher_container__2drcy","button":"LanguageSwitcher_button__30cUh","activeButton":"LanguageSwitcher_activeButton__1ZeSt"};